module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.tagArray), function(tag, tagIndex) {
    return _c('v-chip', {
      key: tagIndex,
      staticClass: "mr-1 mt-1",
      attrs: {
        "close": "",
        "dark": "",
        "color": tag.colour
      },
      on: {
        "click:close": function($event) {
          return _vm.remove(tag)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("space")(tag._id)))])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0adf0f7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TagsView.vue
// module id = 2443
// module chunks = 1